import { render } from "./Privacy.vue?vue&type=template&id=096cd2bd&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=096cd2bd&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/PhpstormProjects/landgoedmorrenrun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096cd2bd"]])

export default __exports__